import React, {Component} from 'react';
import {Form, Input, Row, Modal, Upload, Button, Icon, Spin} from 'antd';
import { uploadNewsletterImage } from '../../modules/Api';

const FormItem = Form.Item;

class Email extends Component {

    static initialState() {
        return {
            template: 'default',
            title: '',
            heading: '',
            body: '',
            button: '',
            link: '',
            image: '',
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            data: props.state,
        }
    }

    commit(e) {
        e.preventDefault();
        this.props.form.validateFields((err, fieldsValue) => {
            if (err) {
                return;
            }
            this.props.commit(Object.assign({}, fieldsValue));
        })
    }

    render() {
        const formItemLayout = {
            labelCol: {
            xs: { span: 24 },
            sm: { span: 8 },
            },
            wrapperCol: {
            xs: { span: 24 },
            sm: { span: 16 },
            },
        };
        const {getFieldDecorator} = this.props.form;
        console.log('handleSubmit', this.handleSubmit);
        return (
            <div style={{direction: 'rtl'}}>
                <Modal
                    title="فرم ارسال ایمیل به اعضا"
                    visible={this.props.visible}
                    onOk={this.commit.bind(this)}
                    onCancel={this.props.close.bind(this)}>
                        <Form onSubmit={this.handleSubmit}>
                            <Row>
                                <FormItem
                                    {...formItemLayout}
                                    label="عنوان"
                                    colon={false}>
                                    {getFieldDecorator('title', {
                                        initialValue: this.props.initialData.title,
                                        rules: [{
                                        required: true, message: 'عنوان را وارد نمایید',
                                        }],
                                    })(
                                        <Input style={{direction:'rtl'}} />
                                    )}
                                </FormItem>
                                
                                <FormItem
                                    {...formItemLayout}
                                    label="متن نامه "
                                    colon={false}>
                                    {getFieldDecorator('body', {
                                        initialValue: this.props.initialData.body,
                                        rules: [{
                                            required: true, message: 'پر کردن این فیلد ضروری است',
                                        }],
                                    })(
                                        <Input.TextArea style={{direction:'rtl'}} /> 
                                    )}
                                </FormItem>

                                <FormItem
                                    {...formItemLayout}
                                    label="لینک دکمه"
                                    colon={false}>
                                    {getFieldDecorator('link', {
                                        initialValue: this.props.initialData.link,
                                        rules: [{
                                            required: true, message: 'پر کردن این فیلد ضروری است',
                                        }],
                                    })(
                                        <Input />
                                    )}
                                </FormItem>

                                <FormItem
                                    {...formItemLayout}
                                    label="عکس خبرنامه"
                                    extra="ایل با حداکثر ۵ مگابایت باشد ، jpg,png,jpeg باشد."
                                    colon={false}>
                                        {getFieldDecorator('file', {
                                    })(
                                    <Upload
                                    name="file"
                                    action=""
                                    customRequest={() => {}}
                                    accept=".jpng,.png,.jpeg"
                                    onChange={f => {
                                        document.getElementById('file_upload_loader').style.display = 'block';
                                        uploadNewsletterImage(f, (src)=>{
                                            this.props.form.setFieldsValue({image: src});
                                            this.setState({image: src});
                                            setTimeout(() => {
                                                document.getElementById('file_upload_loader').style.display = 'none'
                                            }, 2000)
                                        });
                                    }}
                                    listType="text"
                                    showUploadList={false}>
                                        <Button>
                                        <Icon type="upload" /> انتخاب فایل
                                    </Button>
                                    </Upload>
                                    )}
                                    {<div id="file_upload_loader" style={{marginRight: '10px', display: 'none'}}><Spin size="small" style={{marginTop: '5px'}}/> در حال آپلود</div>}
                                </FormItem>

                                {this.state.image && <a href={this.state.image} target="blank">Image link</a>}

                                <FormItem
                                    {...formItemLayout}
                                    label="لینک عکس"
                                    style={{ display: 'none' }}
                                    colon={false}>
                                        {getFieldDecorator('image', {
                                        initialValue: this.props.initialData.image,
                                            rules: [{
                                            required: true, message: 'لینک عکس را وارد کنید',
                                        }],
                                    })(
                                    <Input />
                                    )}
                                </FormItem>
                            </Row>
                        </Form>
                </Modal>
            </div>
        )
    }
}


Email.defaultProps = {
    initialData: {},
    visible: false,
    open: () => {},
    close: () => {},
    commit: () => {},
}

export default Form.create()(Email);



// WEBPACK FOOTER //
// ./src/components/Email/index.js